import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Meta } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { SeoService } from 'src/app/services/seo.service';

@Component({
    selector: 'app-mb',
    templateUrl: './mb.component.html',
    styleUrls: ['./mb.component.scss'],
    imports: [CommonModule,FormsModule,ReactiveFormsModule]
})
export class MbComponent implements OnInit {

  title = "Catholic Affiliate Investment Program";

  friendlyUrl = ""

  constructor(public router: Router, public activatedRoute: ActivatedRoute, private seoservice: SeoService, private meta: Meta) { }

  ngOnInit() {
    this.seoservice.updateTitle(this.title);
  	this.meta.addTag({name: 'keywords', content: 'mensuram bonam'});
    this.meta.addTag({name: 'description', content: 'Investing for Catholics Catholic and Mensuram Bonam.'});
    this.meta.addTag({name: 'author', content: 'Investing for Catholics (IFC)'});
    this.meta.addTag({name: 'robots', content: 'index, follow'});

    this.activatedRoute.params.subscribe(resp => {
      this.friendlyUrl = resp.friendlyUrl?resp.friendlyUrl: "";
// $&(resp.friendlyUrl)
    })
  }

  navigate(path: string) {

    this.router.navigate(["/mb/"+path])

  }

}
